<div class="property-info">
    @if (selectedSale()) {
        <div class="sale-details">
            @if (showUncertainPriceDescription) {
                <div class="uncertain-sale-decription-wrapper">
                    <div class="close-button" (click)="showUncertainPriceDescription = false">
                        <h2>Usikker pris</h2>
                        <div class="uncertain-sale-description">{{ selectedSale().uncertainPriceReason }}</div>
                    </div>
                </div>
            }

            @if (selectedSale().saleStatus == saleStatus.sold) {
                <div class="sale-wrapper">
                    @if (selectedSale().priceAssumption) {
                        <div class="sale-row">
                            Prisantydning <span>{{ selectedSale().priceAssumption | number: "1.0-0" | dash }}</span>
                        </div>
                    }
                    <div class="sale-row">
                        {{ selectedSale().saleInfoText }}
                        <span
                            class="sale-text"
                            [class.sale-large-text]="!selectedSale().commonDebt"
                            [class.is-uncertain]="selectedSale().uncertainPrice"
                            (click)="showPriceDescription()"
                            >{{ selectedSale().salesPrice | number: "1.0-0" | dash }}</span
                        >
                    </div>
                    @if (selectedSale().commonDebt) {
                        <div class="sale-row">
                            Fellesgjeld <span class="sale-text">{{ selectedSale().commonDebt | number: "1.0-0" | dash }}</span>
                        </div>
                        <div class="sale-row">
                            Totalt
                            <span class="sale-text sale-large-text" [class.is-uncertain]="selectedSale().uncertainPrice">{{
                                selectedSale().totalPrice | number: "1.0-0" | dash
                            }}</span>
                        </div>
                    }
                    @if (selectedSale().squareMeterPrice) {
                        <div class="sale-row">
                            m² pris <span>{{ selectedSale().squareMeterPrice | number: "1.0-0" | dash }}</span>
                        </div>
                    }
                </div>
            } @else if (selectedSale().saleStatus == saleStatus.forSale) {
                <div class="sale-wrapper">
                    @if (selectedSale().isOutdated) {
                        <div class="sale-row">Antatt trukket pga liggetid over 270 d</div>
                    }
                    <div class="sale-row">
                        {{ selectedSale().saleInfoText }}
                        <span
                            class="sale-text"
                            [class.sale-large-text]="!selectedSale().commonDebt"
                            [class.is-uncertain]="selectedSale().uncertainPrice"
                            (click)="showPriceDescription()"
                            >{{ selectedSale().priceAssumption | number: "1.0-0" | dash }}</span
                        >
                    </div>
                    @if (selectedSale().commonDebt) {
                        <div class="sale-row">
                            Fellesgjeld <span class="sale-text">{{ selectedSale().commonDebt | number: "1.0-0" | dash }}</span>
                        </div>
                        <div class="sale-row">
                            Totalt
                            <span class="sale-text sale-large-text" [class.is-uncertain]="selectedSale().uncertainPrice">{{
                                selectedSale().totalPriceAssumption | number: "1.0-0" | dash
                            }}</span>
                        </div>
                    }
                    @if (selectedSale().squareMeterPrice) {
                        <div class="sale-row">
                            m² pris <span class="sale-text">{{ selectedSale().squareMeterPrice | number: "1.0-0" | dash }}</span>
                        </div>
                    }
                </div>
            } @else if (selectedSale().saleStatus == saleStatus.withdrawn) {
                <div class="sale-wrapper">
                    @if (selectedSale().isOutdated) {
                        <div class="sale-row">Antatt trukket pga liggetid over 270 d</div>
                    }
                    <div class="sale-row space-between">
                        <span>{{ splitSaleInfoText(selectedSale().saleInfoText, true) }}</span>
                        <span>{{ splitSaleInfoText(selectedSale().saleInfoText, false) }}</span>
                    </div>

                    <div class="sale-row">
                        Forsøkt solgt for <span class="sale-text sale-large-text">{{ selectedSale().priceAssumption | number: "1.0-0" | dash }}</span>
                    </div>
                    @if (selectedSale().commonDebt) {
                        <div class="sale-row">
                            Fellesgjeld <span class="sale-text">{{ selectedSale().commonDebt | number: "1.0-0" | dash }}</span>
                        </div>
                    }
                    @if (selectedSale().squareMeterPrice) {
                        <div class="sale-row">
                            m² pris <span class="sale-text">{{ selectedSale().squareMeterPrice | number: "1.0-0" | dash }}</span>
                        </div>
                    }
                </div>
            }
        </div>

        <div class="links">
            @if (hasValueAssistant()) {
                <a target="_blank" [routerLink]="['/resolve/valuateEstate']" [queryParams]="{ unitId: selectedSale().unitId }" class="open-in-evinfo">
                    <span>Åpne i Verdiassistent</span>
                    <div class="external-link-icon"></div>
                </a>
            }
            @if (!selectedSale().isAttachedSale) {
                <a target="_blank" [routerLink]="['/resolve/infopage']" [queryParams]="{ unitID: selectedSale().unitId }" class="open-in-evinfo">
                    <span>Åpne i evInfo</span>
                    <div class="external-link-icon"></div>
                </a>
            }

            @if (canCreateAppraisal() && hasHideStartNewAppraisalButton() === false) {
                <a
                    target="_blank"
                    [routerLink]="['/resolve/create-appraisal']"
                    [queryParams]="{
                        estateId: selectedSale().estateId,
                        addressId: selectedSale().addressId,
                        organizationNumber: selectedSale().organizationNumber,
                        shareNumber: selectedSale().shareNumber
                    }"
                    class="see-finn"
                >
                    <div class="etakst-icon"></div>
                    <span>Opprett etakst</span>
                    <div class="external-link-icon"></div>
                </a>
            }

            @if (selectedSale().hasProspect) {
                <a target="_blank" class="see-finn" (click)="getProspect(selectedSale().estateSaleId)">
                    <div class="finn-icon"></div>
                    <span>Se Finn-annonse</span>
                    <div class="external-link-icon"></div>
                </a>
            }
        </div>
        <mini-infocard-realestate-properties [keyInfo]="selectedSale()"></mini-infocard-realestate-properties>
    }
</div>
